
import { Company } from "@/models/company";
import { CtepService } from "@/services/ctep-service";
import { TerminalOwner } from "@/utils/ctep/terminal-owner";
import Vue from "vue";
import { DataTableCompareFunction, IDataTableColumn } from "winfakt-vue-components";
import AppCompanyCtepRegister from "./CompanyCtepRegister.vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";
import AppCompanyCtepChangeNickname from "./CompanyCtepChangeNickname.vue";

export default Vue.extend({
	data(){
		return {
			connectedTerminals: [] as TerminalOwner[],
			selectedRows: [] as TerminalOwner[],
			isRegistering: false,
			isFetching: false,
			toChangeNicknameTerminal: null as null | TerminalOwner
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "TerminalID",
					width: "150px"
				},
				{
					name: "Type",
					property: "Type",
					width: "150px"
				},
				{
					name: "Nickname",
					property: "NickName",
					width: "300px"
				}
			];
		},
		registerDisabled():boolean{
			return false;
		},
		changeNicknameDisabled():boolean {
			return this.selectedRows.length != 1;
		},
		unregisterDisabled():boolean {
			return this.selectedRows.length != 1;
		},
		terminalCompareFunc():DataTableCompareFunction {
			return function(a:TerminalOwner, b:TerminalOwner):boolean {
				return a.TerminalID == b.TerminalID;
			};
		}
	},
	methods: {
		async fetch(){
			if (this.isFetching) return;
			this.isFetching = true;
			try{
				this.connectedTerminals = await CtepService.getTerminalsByCompanyId(this.value.id);
			}finally{
				this.isFetching = false;
			}
		},
		registerClicked(){
			this.isRegistering = true;
		},
		changeNicknameClicked(){
			if (this.selectedRows.length != 1) return;
			this.toChangeNicknameTerminal = this.selectedRows[0];
		},
		async unregisterClicked(){
			if (this.selectedRows.length != 1) return;
			let toUnregisterTerminal = this.selectedRows[0];
			let text = `Weet je zeker dat je terminal ${toUnregisterTerminal.toString()} wilt ontkoppelene van dit account?`;
			let result = await this.$wf.confirm(text, "Ja", "Nee", "Waarschuwing", "warning");
			if (!result) return;
			await CtepService.unregisterTerminal(toUnregisterTerminal.TerminalID);
			this.selectedRows.splice(0,this.selectedRows.length);
			this.fetch();
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppCompanyCtepRegister,
		AppCompanyEditWrapper,
		AppCompanyCtepChangeNickname
	}
});
